import React from 'react'

const Manual_yappy_creacion_grupos = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold text-4xl text-[#002D33] mb-5">Yappy - Creación de Grupos y Unidades de cobro</h2>
        <iframe
          src="https://scribehow.com/embed/Yappy__Creacion_de_Grupos_y_Unidades_de_cobro__rcmGhzuGRECzXn8plvrAnQ?as=scrollable"
          className="scribe-iframe-general-191"
          width="100%"
          height="4700"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_yappy_creacion_grupos
